export default "__VITE_ASSET__Yybt717___"